export default [
  {
    path: '/month/list',
    name: 'month-list',
    component: () => import('@/views/month/index.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Month List',
      breadcrumb: [{ title: 'Dashboard', url: '/dashboard' }, { title: 'Month' }, { title: 'Month List', active: true }],
      permissions: ['month_management_list']
    }
  },
  {
    path: '/month/add',
    name: 'create-month',
    component: () => import('@/views/month/action.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Add Month',
      parent: 'monthList',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Month', url: '/month/list' },
        { title: 'Add Month', active: true }
      ],
      permissions: ['month_management_create']
    }
  },
  {
    path: '/month/:id/edit',
    name: 'edit-month',
    component: () => import('@/views/month/action.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Edit Month',
      parent: 'monthList',
      // breadcrumb: [
      //   { title: 'Dashboard', url: '/dashboard' },
      //   { title: 'Month', url: '/month/list' },
      //   { title: 'Edit month', active: true }
      // ],
      permissions: ['month_management_edit']
    }
  }
]
